










































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { MdTable } from '@/module/graphql'
import { ElTree } from 'element-ui/types/tree'
import CmpBrCatalog from '@/module/butler/views/components/cmp-br-catalog.vue'

@Component({
  components: { CmpBrCatalog }
})
export default class IcmpMdTableChooser extends Vue {
  @Ref() private readonly catalogTree!: CmpBrCatalog
  @Prop() readonly selectedTableCodes: string[]

  private mVisible = true

  private mSelectedMdTables: string[]

  onCheckChange(data: any[]) {
    this.mSelectedMdTables = data.filter(table => !table.children || table.children.length === 0)
  }
  chooseCatalog() {
    this.mVisible = false
    this.$emit('select', this.catalogTree.getCheckedNodes()
      .filter((node: { entity: MdTable }) => node.entity)
      .map((node: { entity: MdTable }) => node.entity))
  }
}
